module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"br":{"title":"Soluções","home":"Home"},"en":{"title":"Solutions","home":"Home"},"es":{"title":"Soluciones","home":"Inicio"}}')
  delete Component.options._Ctor
}
